import { React, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

import NoticeList from './NoticeList';
import InfoPagination from '../../../Component/MemberComponent/InfoPagination';

function NoticeListView() {
  const history = useHistory();
  const { t } = useLanguage();

  const [data, setData] = useState([]);
  const [nowPage, setNowPage] = useState(0);
  const [useData, setUseData] = useState([]);

  useEffect(() => {

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('notice/', 'POST');
        if (responseData.status === 200) setData(responseData.data);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  useEffect(() => {
    let newDataList = data.slice((nowPage * 10), (nowPage * 10) + 10);
    setUseData(newDataList);
  }, [nowPage, data])

  function addNoticeClick() {
    history.push('/notice/create');
  }
  
  function onClickNextPage() {
    if (nowPage + 1 < Math.ceil(data.length/10)) setNowPage(nowPage + 1);
  }

  function onClickPrevPage() {
    if ((nowPage - 1) >= 0) setNowPage(nowPage - 1);  
  }

  return (
    <TopLevelWrapper>
      <TopBarWrapper>
        <TextWrapper>
          <Title>{t('noticePage.title')}</Title>
          <Explanation>{t('noticePage.description')}</Explanation>
        </TextWrapper>
        <ButtonWrapper>
          <AddButton onClick={addNoticeClick}>{t('noticePage.addNotice')}</AddButton>
        </ButtonWrapper>
      </TopBarWrapper>
      <NoticeList data={useData}/>
      <PaginationWrapper>
        <InfoPagination 
          nowPage={nowPage} 
          totalPage={Math.ceil(data.length/10)}
          nextClickFn={onClickNextPage}
          prevClickFn={onClickPrevPage}/>
      </PaginationWrapper>
    </TopLevelWrapper>
  )
}

export default NoticeListView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 42px;

  transition: all 0.3s ease-in-out;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 992px;

  margin-left: 28px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover){
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.subKeyHover};
    }
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  margin-bottom: 96px;
`;